<template>
    <header class="header">
        <div class="container">
            <div class="header__inner">
                <router-link class="header__logo" to="/"><img src="@/assets/img/logo.png" alt="Logo"></router-link>
                <div class="header__user">
                    <img src="@/assets/img/user_icon.svg" alt="">
                    {{ userName }}
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    props: ['user-name'],
}
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    padding: 62px 0;
    @media (max-width: 767px) {
        padding: 32px 0;
    }

    &__inner {
        display: flex;
        justify-content: space-between;
    }

    &__logo {
        width: 248px;
        height: 103px;
        display: block;

        & img {
            object-fit: contain;
        }

        @media (max-width: 1023px) {
            width: 216px;
            height: 90px;
        }
        @media (max-width: 767px) {
            width: 114px;
            height: 48px;
        }
        @media (max-width: 479px) {
            display: none;
        }
    }

    &__user {
        display: flex;
        gap: 26px;
        align-items: center;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 29px;
        color: rgba(83, 67, 64, 0.9);

        & img {
            width: 32px;
            height: 36px;
            @media (max-width: 767px) {
                width: 24px;
                height: 27px;
            }
        }

        @media (max-width: 1023px) {
            font-size: 22px;
        }
        @media (max-width: 767px) {
            font-size: 20px;
        }
    }
}
</style>